










import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import ActionAnswerForm from '@/components/action_list/ActionAnswerForm.vue';

@Component({
  components: {
    Header,
    ActionAnswerForm,
    Footer,
  },
})
export default class ActionAnswer extends Vue {}
